module.exports = __webpack_public_path__ + "static/img/yk4300.bfa7bce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hardware/yk4300.png
// module id = WgGr
// module chunks = 1